if not App.angularApp?
    return

App.angularApp.directive 'mfWhenScroll', () ->
    return {
        link: (scope, element, attrs) ->

            elem = element[0]

            element.bind 'scroll', debounce () ->
                location = elem.scrollTop + elem.offsetHeight + 5

                if location >= elem.scrollHeight
                    scope.$apply attrs.mfWhenScroll
            , 500
    }
